import styled from "styled-components";

const backimg = "../../../assets/images/blog3.png";

export const Wrapper = styled.div`
  width: 100%;
  background: ${(props) => (props.themes ? "#04031D" : "#f9f9f9")};
  color: ${(props) => (props.themes ? "#f9f9f9" : "#04031D")};
`;
export const Headers = styled.div`
  min-height: 300px;
  background: url(${backimg});
  background-repeat: no-repeat;
  background-size: cover;
  padding-left: 40%;
`;
export const Container = styled.div`
  width: 100%;
  padding: 1em;

  @media (min-width: 789px) {
    grid-template-columns: repeat(2, 1fr);
    max-width: 90%;
    margin: auto;
  }
  @media (min-width: 1100px) {
    grid-template-columns: repeat(3, 1fr);
    max-width: 80%;
    margin: auto;
  }
`;
